import React, { useState } from 'react';
import { colors, css, fonts, frames, useMediaQuery } from "../../../Styles";
import PageHeader from '../../../Components/BaseComponents/pageHeader';
import { useTranslation } from 'react-i18next';
import GroupCard from '../../../Components/Animals/groupCard';
import { AnimalGroupData as GroupData } from '../../../Assets/TestData/animalGroups';
import { Button, ButtonList, InputField, Modal } from '../../../Components';
import { ButtonTypes, ListStyle_Types } from '../../../Definitions';

export default function AnimalsGroups() {
  const { t } = useTranslation();
  const [addGroupModal, setAddGroupModal] = useState<boolean>(false)
  const hideBtns = useMediaQuery(`(max-width: 600px)`);
  const hideBtnText = useMediaQuery(`(max-width: 450px)`);

  const addGroupModalComponent = (
    <Modal
      isModalOpen={!!addGroupModal}
      overrides={{ 
        isPrimaryComponent: true 
      }}
      modalHeader={t("animalPages.animalGroups.newGroup")}
      // modalSubHeader={}
      onCloseBtn={() => setAddGroupModal(false)} 
    >
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "40px"}}>
        <div>
          <p style={{ ...fonts.header, ...fonts.textShadow, ...fonts.fontSize4, color: colors.greyLightTertiary, padding: "0px 0px 2px 22px" }}>{t("animalPages.animalGroups.groupName")}</p>
          <InputField textStart={true}/>
        </div>
        <Button
          content={t("animalPages.animalGroups.createGroup")}
          buttonType={ButtonTypes.primaryButton}
          overrides={{
            baseButton: {...css.button_FitContent}
          }}
        />
      </div>
    </Modal>
  )
  
  return (
    <frames.Page_inner>
      <frames._page_inner_header>
        <div style={{display: "flex", flexDirection: "row", alignItems: "start", justifyContent: "space-between"}}>
          <PageHeader topHeader={t("globalMenu.animals")} subHeader={t("globalMenu.animalGroups")}/>
          {/* <ButtonList
            contents={["Edit group"]}
            onClick={(i => {
              if (i === 0) {}
            })}
            buttonType={ButtonTypes.primaryButton}
            overrides={{
              baseButton: { ...( !hideBtns ? {...css.button_FitContent, minWidth: "none" } : {backgroundColor: colors.greyDarkSecondary})},
            }}
            listOverrides={{
              listStyle: !hideBtns ? ListStyle_Types.horizontal : ListStyle_Types.vertical,
            }}
            responsiveOverrides={{
              isResponsive: !hideBtns ? false : true,
              popoverStyle: { backgroundColor: colors.greyDarkPrimary, padding: "20px", borderRadius: "10px", boxShadow: "0px 0px 5px 2px"+colors.blackPrimary+"4d" },
              openContent: hideBtnText ? "" : "Options"
            }}
          /> */}
        </div>
      </frames._page_inner_header>
      <frames._page_inner_content>
        <frames.CardsColumnCount>
            <Button 
              content={t("animalPages.animalGroups.createGroup")}
              // subContent={t("feed.feedCurve.createFeedCurveFromScratch")} 
              onClick={() => setAddGroupModal(true)}
              buttonType={ButtonTypes.cardButton}
              overrides={{
                baseButton: {height: "50px"}
              }}
            />
          {GroupData.map((group) => (
            <GroupCard key={group.groupId} selectedGroupId={group.groupId}/>
          ))}
        </frames.CardsColumnCount>
      </frames._page_inner_content>
    
    {addGroupModalComponent}
    </frames.Page_inner>
  )
}